<div class="td-cnt-ext" [style.top.px]="topPx">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}" id="teiasoftDialogItem">
        <div class="td-cnt-title">
            <div>
                <i *ngIf="action == 'create'" class="fal fa-plus dialog-icon"></i>
                <span *ngIf="action == 'create'" class="te-title">{{'users.createUser' | translate}}</span>
                <i *ngIf="action == 'edit'" class="fal fa-pencil dialog-icon"></i>
                <span *ngIf="action == 'edit'" class="te-title">{{'users.editUser' | translate}}</span>
            </div>
        </div>
        <div class="td-cnt-body">
            <!-- BREADCRUMB -->
            <teiasoft-breadcrumb *ngIf="action == 'create'" [dataSet]="createUserSteps" [columnToShow]="'action'"
                [activeIndex]="selectedStepIndex" (tbcClick)="tbcClick($event)"
                style="width:100%"></teiasoft-breadcrumb>
            <!-- SEARCH USER -->
            <div *ngIf="action == 'create' && selectedStepIndex == 0">
                <div class="tm-row">
                    <teiasoft-input [type]="'text'" [labelText]="'users.searchAd' | translate" [isMobile]="isMobile"
                        [isRequired]="true" [disabled]="false" [value]="userInAd" style="width:75%"
                        (onInput)="onInputUserInAd($event)" [noMinWidth]="true" [readOnly]="false" class="mr-5"
                        (keydown)="onKeyDown($event)"></teiasoft-input>

                    <teiasoft-button (onClick)="onSearchInAdClick()" [type]="'tb-primary'" style="margin-top: 3.5vh;"
                        [text]="'users.searchAd' | translate" [isMobile]="isMobile" [disabled]="buttonSearchAdDisabled">
                    </teiasoft-button>
                </div>
                <div class="tm-row">
                    <div *ngIf="isLoadedAdUsers" class="cnt-grid">
                        <teiasoft-grid style="width:100%" [columnsToShow]="['adUsername','adOffice']"
                            [dataSet]="adUsersForGrid!" [showFooter]="false" [selectable]="false"
                            [disableAllSelection]="false" [theme]="globals.theme!" [autoWidth]="false"
                            [showEditIcon]="false" [minWidthVw]="minWidthVw" [dateFormat]="globals.dateFormat!"
                            [selectedRow]="selectedRow" [dateTimeFormat]="globals.dateTimeFormat!"
                            (rowClick)="rowClick($event)"></teiasoft-grid>
                    </div>

                </div>
            </div>
            <div *ngIf="(selectedStepIndex == 1 && action == 'create') || action == 'edit'">
                <div class="tm-row">
                    <div class="cnt-32">
                        <teiasoft-input [type]="'text'" [labelText]="'grid.AdUsername' | translate"
                            [isMobile]="isMobile" [isRequired]="true" [value]="userSelected" style="width:100%"
                            [maxLength]="50" [readOnly]="false" [disabled]="true" class="mr-5"></teiasoft-input>
                    </div>

                    <div class="cnt-32">
                        <teiasoft-select [labelText]="'grid.AdOffice' | translate" [isMobile]="isMobile"
                            [isRequired]="false" [disabled]="selectOfficeDisabled" [optionsList]="officeOptionList"
                            [spaceLabel]="true" [noMinWidth]="true" [defaultValue]="officeSelectedId"
                            (onSelected)="onSelectedOffice($event)" style="width:100%" [tabIndex]="0"
                            [readOnly]="false"></teiasoft-select>
                    </div>

                    <div class="cnt-32">
                        <teiasoft-select [labelText]="'grid.Mill' | translate" [isMobile]="isMobile"
                            [isRequired]="false" [optionsList]="millsOptionList" [spaceLabel]="true" [noMinWidth]="true"
                            [defaultValue]="millSelectedId" (onSelected)="onSelectedMill($event)" style="width:100%"
                            [tabIndex]="1" [readOnly]="false"></teiasoft-select>
                    </div>
                </div>
                <div class="tm-row">
                    <teiasoft-select [labelText]="'users.selectAGroup' | translate" [isMobile]="isMobile"
                        [isRequired]="false" [optionsList]="groupsOptionList" [spaceLabel]="true" [noMinWidth]="true"
                        [clearValue]="clearValue" [disabled]="groupsOptionList.length == 0"
                        (onSelected)="onSelectedGroup($event)" style="width:48%" [tabIndex]="2"
                        [readOnly]="false"></teiasoft-select>
                    <div class="cnt-32" style="align-items: flex-end;">
                        <teiasoft-input [type]="'text'" [labelText]="'grid.SapEmployeeNumber' | translate"
                            [isMobile]="isMobile" [isRequired]="false" [disabled]="sapEmployeeNumberDisabled"
                            [value]="userToSave.sapEmployeeNumber" [maxLength]="50" [readOnly]="false"
                            [noMinWidth]="true" (onInput)="onInputSapEmployeeNumber($event)" style="width:100%"
                            [tabIndex]="3" [noMinWidth]="true"></teiasoft-input>
                    </div>
                </div>
                <div class="tm-row">
                    <span class="span-assigned">{{'users.assignedGroups' | translate}}*</span>
                </div>
                <div class="tm-row">
                    <span *ngIf="!groupsList || groupsList.length == 0" class="no-data">{{'users.noAssignedGroups' |
                        translate}}</span>
                    <div class="ti-chips-wrapper">
                        <teiasoft-chips [values]="groupsList" [multiSelection]="true" style="width: calc(100% - 2.4vw);"
                            (deleteValue)="deleteValue($event)"></teiasoft-chips>
                    </div>
                </div>
            </div>
        </div>
        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (onClick)="onSaveUserClick()" class="mr-5" [type]="'tb-secondary'"
                [text]="'commons.save' | translate" [isMobile]="isMobile" [disabled]="isDisabledSave()">
            </teiasoft-button>
            <teiasoft-button (onClick)="onCloseModalClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>